<template>
  <transition enter-active-class="animated faster zoomIn">
    <div class="comment_wrap">
      <comment-item
        :image="image"
        :comments="comments"
        @create="createComment"
        @change="changeComment"
        @reset="resetCommentsData"
      ></comment-item>
    </div>
  </transition>
</template>

<script>
import API from "../../api/api.js"
import commentItem from "./components/CommentItem"
export default {
    components: {
        commentItem
    },
    data() {
        return {
            image: {}, // 图片相关信息
            comments: [] // 评论相关
        }
    },
    computed: {
        imageId() {
            return this.$route.query.image_id
        }
    },
    mounted() {
        this.getImage()
    },
    methods: {
        async getImage(siblingId) {
            let teamId = localStorage.teamId
            let imageId = siblingId || this.imageId
            let res = await API.image.getImageInfo(teamId, imageId)

            if (res) {
                let data = res.data
                this.image = data.result
                this.image.url = window.mtd.handleImg(this.image.url,{
                                    ali:this.$root.isSupportWebp?'?x-oss-process=image/format,webp':'',
                                    qiniu:''
                                })

                this.getImageComments(this.image.versions[0].id)
            }
        },
        async getImageComments(vid) {
            let res = await API.image.getImageComments(this.imageId, vid, 1, 100)
            if (res) {
                let data = res.data
                this.comments = data.result.map(ele => {
                    ele.selected = false
                    this.commentsSort(ele)
                    return ele
                })
            }
        },
        commentsSort(ele) {
            if (ele.replies && ele.replies.length) {
                ele.replies.sort((a, b) => {
                    return Number(a.create_time) - Number(b.create_time)
                })
            }
        },
        createComment(dotInfo) {
            this.comments.push(dotInfo)

            MtaH5.clickStat("comment")
        },
        changeComment(dotInfo) {
            for (let x in dotInfo) {
                this.comments[this.comments.length - 1][x] = dotInfo[x]
            }
        },
        resetCommentsData(data) {
            this.comments = data.map(ele => {
                this.commentsSort(ele)
                ele.selected = false
                return ele
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.comment_wrap {
    height: 100%;
    box-sizing: border-box;
}
</style>
